<template>
  <b-table
    class="tablePro"
    :data="data.length == 0 ? [] : data"
    :bordered="true"
    :narrowed="true"
    :striped="true"
    :columns="columns"
    :row-class="(row, index) => rowIndication.includes(index) && 'floorLevel'"
  >
    <template slot="header" slot-scope="props">
      <div v-if="props.column.meta" style="color: Gray">{{ props.column.label }}</div>
      <div v-else>{{ props.column.label }}</div>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nothing here.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
export default {
  props: ['data', 'columns', 'rowIndication'],
  created() {},
  methods: {
    getRowClass(row, index) {
      //return this.rowIndication.includes(index) && 'level'
    }
  }
}
</script>

<style lang="scss">
@import '../../sass/main.scss';

.tablePro {
  width: max-content;
}
.floorLevel {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
  td:first-child {
    padding-left: 30px;
  }
}
.th-wrap:not(.is-centered) {
  padding-top: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Office/ProjectStatusTable.vue